import { motion, useScroll, useTransform } from "framer-motion";
import { useRef } from "react";

export const FrameDormant = () => {
  const ref = useRef<HTMLDivElement>(null);
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["start start", "end start"]
  });

  const testimonialOpacity = useTransform(scrollYProgress, [0, 0.3], [0, 1]);
  const testimonialX = useTransform(scrollYProgress, [0, 0.3], [-20, 0]);
  const threadOpacity = useTransform(scrollYProgress, [0.2, 0.4], [0, 0.6]);
  const threadScaleX = useTransform(scrollYProgress, [0.2, 0.5], [0, 1]);

  return (
    <section ref={ref} className="min-h-screen flex items-center relative overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full">
        <div className="grid md:grid-cols-2 gap-12 items-center">
          {/* Left: Dormant testimonial */}
          <motion.div
            style={{ opacity: testimonialOpacity, x: testimonialX }}
            className="relative"
          >
            <div className="ink-border rounded-sm p-8 bg-muted/20">
              <p className="font-editorial text-2xl md:text-3xl text-muted-foreground/50 italic leading-relaxed">
                "They did a good job and we were happy with the results. Would recommend to others."
              </p>
            </div>
            
            {/* Thread line waiting */}
            <motion.div
              className="absolute right-0 top-1/2 -translate-y-1/2 translate-x-full w-24 h-px origin-left"
              style={{ 
                opacity: threadOpacity,
                scaleX: threadScaleX,
                background: "linear-gradient(to right, hsl(var(--brand-600) / 0.4), hsl(var(--brand-500) / 0.6))"
              }}
            />
          </motion.div>

          {/* Right: Copy */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.3 }}
            className="space-y-6"
          >
            <p className="text-xl md:text-2xl text-muted-foreground leading-relaxed">
              Every company has them.
            </p>
            <p className="text-xl md:text-2xl text-muted-foreground leading-relaxed">
              Client wins. Praise emails. 5-star reviews.
            </p>
            <p className="text-xl md:text-2xl text-muted-foreground leading-relaxed">
              Sitting in folders. Collecting digital dust.
            </p>
            <p className="font-editorial text-4xl md:text-5xl text-foreground">
              Dormant.
            </p>
          </motion.div>
        </div>
      </div>
    </section>
  );
};
